<template>
  <banner-inscripciones />
  <tarifas-component />
</template>

<script>
import BannerInscripciones from "@/components/inscripciones/BannerInscripciones.vue";
import TarifasComponent from "@/components/inscripciones/TarifasComponent.vue";
export default {
  components: { BannerInscripciones, TarifasComponent },
};
</script>

<style></style>
